import React, { type ReactElement } from 'react';
import { Divider, Flex, SafeAreaBottomSpacing } from '@banhala/ui-kit';

export const BottomTabBarContainer: React.FC<{
  width: number;
  children: ReactElement[];
}> = props => {
  return (
    <Flex width={'100%'} alignItems={'center'} backgroundColor={'white'}>
      <Divider size={'small'} />
      <Flex.Row width={props.width}>{props.children}</Flex.Row>
      <SafeAreaBottomSpacing />
    </Flex>
  );
};
